import React, { PureComponent, Fragment } from "react";
import Form from "js/pages/Admin/Programa/Beneficio/Edit/MyForm.js";
import BeneficioGraphQL from "js/graphql/resolvers/beneficio.resolver";
import LocacionGraphQL from "js/graphql/resolvers/locacion.resolver";
import SegmentoGraphQL from "js/graphql/resolvers/segmento.resolver";
import RubroGraphQL from "js/graphql/resolvers/rubro.resolver";
import { addImageURL } from "js/constants";
import { getUrl } from "js/utils";
import { addChecked, filter } from "js/pages/Admin/Programa/Catalogo/utils.js";
import Dialog from "js/pages/Admin/Programa/Beneficio/Edit/TipoBeneficioDialog.js";
import _, { isEmpty } from "lodash";

class Edit extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        estado: "ACTIVO"
      },
      sucursales: [],
      tipos: [],
      paises: [],
      rubros: [],
      segmentos: [],
      paisesSeleccionados: [],
      rubrosSeleccionados: [],
      segmentosSeleccionados: [],
      codigosFijos: [{ id: 0, codigo: "", segmentosSeleccionados: [] }],
      codigosImportados: [],
      tipoCodigo: "", // Si tipo código es "" deshabilito el check de beneficio con código
      nextIdCodigoFijo: 1,
      logo: [],
      imagenes: [],
      fechaValidezDesde: null,
      fechaValidezHasta: null,
      fechaVencimiento: null,
      disabled: false,
      errors: null,
      open: false,
      archivoImportado: null // File object for imported codes
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      disabled:
        nextProps.match.params.edit !== "edit" &&
        nextProps.match.params.idBeneficio !== "new"
    });
  }

  async fetchData() {
    const { client } = this.props;
    const {
      match: {
        params: { id }
      }
    } = this.props;

    await client
      .query({
        query: LocacionGraphQL.queries.getLocacionesInput,
        fetchPolicy: "network-only",
        variables: {
          idPrograma: parseInt(id) || id
        }
      })
      .then(res => {
        const paises = filter(res.data.getPaises || []);
        this.setState({ paises });
      });

    await client
      .query({
        query: SegmentoGraphQL.queries.getSegmentosInput,
        fetchPolicy: "network-only",
        variables: {
          idPrograma: parseInt(id) || id
        }
      })
      .then(res => {
        const segmentos = filter(res.data.getSegmentos || []);
        this.setState({ segmentos });
      });

    await client
      .query({
        query: RubroGraphQL.queries.getRubrosInput,
        fetchPolicy: "network-only",
        variables: {
          idPrograma: parseInt(id) || id
        }
      })
      .then(res => {
        const rubros = filter(res.data.getRubros || []);
        this.setState({ rubros });
      });
  }

  async componentDidMount() {
    const { client } = this.props;
    const {
      match: {
        params: { idBeneficio, id, edit }
      }
    } = this.props;

    if (idBeneficio !== "new") {
      await client
        .query({
          query: BeneficioGraphQL.queries.getBeneficioById,
          fetchPolicy: "network-only",
          variables: {
            idBeneficio: parseInt(idBeneficio) || idBeneficio,
            idPrograma: parseInt(id) || id
          }
        })
        .then(res => {
          const page = res.data.getBeneficio.itemsPagina[0];
          const paises = filter(res.data.getPaises || []);
          const rubros = filter(res.data.getRubros || []);
          const segmentos = filter(res.data.getSegmentos || []);

          const paisesSeleccionados = filter(page.paises || []);
          const zonasSeleccionadas = filter(page.zonas || []);
          const localidadesSeleccionadas = filter(page.localidades || []);
          const rubrosSeleccionados = filter(page.rubros || []);
          const subRubrosSeleccionados = filter(page.subrubros || []);
          const segmentosSeleccionados = filter(page.segmentos || []);

          paisesSeleccionados.map(item =>
            addChecked(paises, "idPais", parseInt(item.idPais) || item.idPais)
          );
          zonasSeleccionadas.map(item =>
            addChecked(paises, "idZona", parseInt(item.idZona) || item.idZona)
          );
          localidadesSeleccionadas.map(item =>
            addChecked(
              paises,
              "idLocalidad",
              parseInt(item.idLocalidad) || item.idLocalidad
            )
          );
          rubrosSeleccionados.map(item =>
            addChecked(
              rubros,
              "idRubro",
              parseInt(item.idRubro) || item.idRubro
            )
          );
          subRubrosSeleccionados.map(item =>
            addChecked(
              rubros,
              "idSubrubro",
              parseInt(item.idSubrubro) || item.idSubrubro
            )
          );
          segmentosSeleccionados.map(item =>
            addChecked(
              segmentos,
              "idSegmento",
              parseInt(item.idSegmento) || item.idSegmento
            )
          );

          // Cargar códigos de beneficio si existen
          let codigosFilasFromDB = [
            { id: 0, codigo: "", segmentosSeleccionados: [] }
          ];
          let nextIdCodigoFijoFromDB = 1;

          if (page.codigosBeneficio && page.codigosBeneficio.length > 0) {
            codigosFilasFromDB = page.codigosBeneficio.map(
              (codigoBeneficio, index) => {
                // Encontrar los segmentos completos basados en los IDs
                const segmentosDelCodigo = codigoBeneficio.segmentos
                  .map(idSegmento => {
                    // Buscar el segmento en la estructura jerárquica
                    const findSegmento = nodos => {
                      for (const nodo of nodos) {
                        if (nodo.idSegmento === idSegmento) return nodo;
                        if (nodo.children) {
                          const found = findSegmento(nodo.children);
                          if (found) return found;
                        }
                      }
                      return null;
                    };
                    return findSegmento(segmentos);
                  })
                  .filter(seg => seg !== null); // Filtrar segmentos no encontrados

                return {
                  id: index,
                  codigo: codigoBeneficio.codigo,
                  segmentosSeleccionados: segmentosDelCodigo
                };
              }
            );
            nextIdCodigoFijoFromDB = page.codigosBeneficio.length;
          }

          let codigosImportadosFromDB = [];
          if (page.tipoCodigo === "IMPORTADOS") {
            codigosImportadosFromDB = page.codigosBeneficio || [];
          }

          this.setState({
            initialValues: {
              ...page,
              beneficioConCodigo:
                page.tipoCodigo !== "" && !_.isNil(page.tipoCodigo)
                  ? true
                  : false,
              //codigosFijos: codigosFilasFromDB,
              sucursales: page.sucursales
                ? page.sucursales.map(s => s._id)
                : [],
              idTipo: page.idTipo ? page.idTipo._id : null
            },
            paises,
            rubros,
            segmentos,
            paisesSeleccionados: paisesSeleccionados
              .concat(zonasSeleccionadas)
              .concat(localidadesSeleccionadas),
            rubrosSeleccionados: rubrosSeleccionados.concat(
              subRubrosSeleccionados
            ),
            segmentosSeleccionados,
            imagenes: page.imagenes,
            tipoCodigo: page.tipoCodigo || "FIJO",
            codigosFijos: codigosFilasFromDB,
            nextIdCodigoFijo: nextIdCodigoFijoFromDB,
            codigosImportados: codigosImportadosFromDB,
            logo: [page.logo],
            fechaValidezDesde: page.fechaValidezDesde,
            fechaValidezHasta: page.fechaValidezHasta,
            fechaVencimiento: page.fechaVencimiento,
            disabled: !(edit === "edit")
          });
        });
    } else {
      this.fetchData();
    }

    await client
      .query({
        query: BeneficioGraphQL.queries.getBeneficioTipos,
        fetchPolicy: "network-only"
      })
      .then(res => {
        this.setState({
          tipos: res.data.getBeneficioTipos ? res.data.getBeneficioTipos : []
        });
      });
  }

  async submit(values) {
    const {
      client,
      history,
      match: {
        params: { idBeneficio, id }
      }
    } = this.props;

    let paises = [];
    let zonas = [];
    let localidades = [];
    let rubros = [];
    let subrubros = [];
    let segmentos = [];
    let e = [];
    console.log("Submitting with values:", values);
    const {
      segmentosSeleccionados,
      rubrosSeleccionados,
      paisesSeleccionados,
      imagenes,
      logo,
      fechaValidezDesde,
      fechaValidezHasta,
      fechaVencimiento,
      codigosFijos,
      codigosImportados,
      archivoImportado
    } = this.state;

    // Log the file when tipoCodigo is IMPORTADOS
    console.log("Archivo importado:", archivoImportado);

    const codigosBeneficio =
      codigosFijos.map(codigo => {
        return {
          codigo: codigo.codigo,
          estado: "ACTIVO",
          segmentos: codigo.segmentosSeleccionados.map(
            segmento => segmento.idSegmento
          )
        };
      }) || [];

    if (
      isEmpty(segmentosSeleccionados) ||
      isEmpty(rubrosSeleccionados) ||
      isEmpty(paisesSeleccionados)
    ) {
      e.push({
        message:
          "Segmentos, Categoría/Subcategoría y País/Zona/Localidad no pueden estar vacíos."
      });
      this.setState({ errors: e });
      return false;
    }

    if (logo.length === 0) {
      e.push({ message: "Tiene que asignar un logo para el beneficio" });
      this.setState({ errors: e });
      return false;
    }

    if (imagenes.length === 0) {
      e.push({
        message: "Tiene que asignar al menos una imagen para el beneficio"
      });
      this.setState({ errors: e });
      return false;
    }

    paisesSeleccionados &&
      paisesSeleccionados.map(item => {
        item.idPais && paises.push(parseInt(item.idPais) || item.idPais);
        item.idZona && zonas.push(parseInt(item.idZona) || item.idZona);
        item.idLocalidad &&
          localidades.push(parseInt(item.idLocalidad) || item.idLocalidad);
        return true;
      });
    rubrosSeleccionados &&
      rubrosSeleccionados.map(item => {
        item.idRubro && rubros.push(parseInt(item.idRubro) || item.idRubro);
        item.idSubrubro &&
          subrubros.push(parseInt(item.idSubrubro) || item.idSubrubro);
        return true;
      });
    segmentosSeleccionados &&
      segmentosSeleccionados.map(
        item =>
          item.idSegmento &&
          segmentos.push(parseInt(item.idSegmento) || item.idSegmento)
      );

    const variables = {
      idPrograma: parseInt(id, 10),
      nombre: values.nombre,
      copete: values.copete,
      descripcion: values.descripcion,
      estado: values.estado,
      stockInfinito: values.stockInfinito ? values.stockInfinito : false,
      stock: values.stock,
      stockSeguridad: values.stockSeguridad,
      idTipo: values.idTipo,
      tipoValidez: values.tipoValidez,
      diasValidez: values.diasValidez,
      fechaValidezDesde: fechaValidezDesde,
      fechaValidezHasta: fechaValidezHasta,
      fechaVencimiento: fechaVencimiento,
      tieneSucursales: values.tieneSucursales,
      cucarda: values.cucarda,
      paginaWeb: values.paginaWeb,
      condiciones: values.condiciones,
      emailProveedor: values.emailProveedor,
      segmentos: segmentos,
      rubros: rubros,
      subrubros: subrubros,
      paises: paises,
      zonas: zonas,
      localidades: localidades,
      logo: logo[0],
      imagenes: imagenes,
      tipoCodigo: values.beneficioConCodigo ? this.state.tipoCodigo : null,
      codigosBeneficio
    };
    await client
      .mutate({
        mutation:
          idBeneficio === "new"
            ? BeneficioGraphQL.mutations.createBeneficio
            : BeneficioGraphQL.mutations.updateBeneficio,
        variables: {
          beneficio:
            idBeneficio === "new"
              ? { ...variables }
              : {
                  ...variables,
                  idBeneficio: parseInt(idBeneficio) || idBeneficio
                },
          file: archivoImportado ? archivoImportado : null
        }
      })
      .then(res => {
        const mensaje =
          "Beneficio " +
          (idBeneficio === "new" ? "creado" : "modificado") +
          " correctamente";
        this.props.openNotification(mensaje);
        history.push(`/admin/programa/${id}/beneficios`);
      })
      .catch(errors => {
        const arr = [];
        arr.push({ message: "Error inesperado" });
        this.setState({
          errors: errors.graphQLErrors.length !== 0 ? errors.graphQLErrors : arr
        });
        return false;
      });
  }

  onChangeImage = image => {
    const formData = new window.FormData();
    formData.append("image", image);
    formData.append("context", "beneficio");
    formData.append("height", 556);
    formData.append("width", 556);
    fetch(addImageURL, {
      method: "POST",
      body: formData
    })
      .then(response => response.json())
      .then(({ url }) => {
        this.setState(({ imagenes }) => ({
          imagenes: imagenes.concat(getUrl(url))
        }));
      })
      .catch(() => console.error("Hubo un error al cargar la imagen a S3"));
  };

  onChangeLogo = image => {
    const formData = new window.FormData();
    formData.append("image", image);
    formData.append("context", "beneficio");
    formData.append("height", 556);
    formData.append("width", 556);
    fetch(addImageURL, {
      method: "POST",
      body: formData
    })
      .then(response => response.json())
      .then(({ url }) => {
        this.setState({
          logo: [getUrl(url)]
        });
      })
      .catch(() => console.error("Hubo un error al cargar la imagen a S3"));
  };

  onRemoveImage = urlToRemove => {
    this.setState(({ imagenes }) => ({
      imagenes: imagenes.filter(url => url !== urlToRemove)
    }));
  };

  onRemoveLogo = urlToRemove => {
    this.setState({
      logo: []
    });
  };

  handleDateChange = key => date => {
    this.setState({
      [key]: date.toISOString()
    });
  };

  onChangePais = paisesSeleccionados => {
    this.setState({ ...paisesSeleccionados });
  };

  onChangeRubro = rubrosSeleccionados => {
    this.setState({ ...rubrosSeleccionados });
  };

  onChangeSegmento = segmentosSeleccionados => {
    this.setState({ ...segmentosSeleccionados });
  };

  onAgregarCodigoFijo = () => {
    const { codigosFijos, nextIdCodigoFijo } = this.state;
    const newFila = {
      id: nextIdCodigoFijo,
      codigo: "",
      segmentosSeleccionados: []
    };
    this.setState({
      codigosFijos: [...codigosFijos, newFila],
      nextIdCodigoFijo: nextIdCodigoFijo + 1
    });
  };

  onEliminarCodigoFijo = id => {
    this.setState({
      codigosFijos: this.state.codigosFijos.filter(fila => fila.id !== id)
    });
  };

  onChangeCodigoFijo = (id, value) => {
    this.setState({
      codigosFijos: this.state.codigosFijos.map(
        fila => (fila.id === id ? { ...fila, codigo: value } : fila)
      )
    });
  };

  onChangeSegmentosCodigoFijo = (id, selectedNodes) => {
    this.setState({
      codigosFijos: this.state.codigosFijos.map(
        fila =>
          fila.id === id
            ? { ...fila, segmentosSeleccionados: selectedNodes }
            : fila
      )
    });
  };

  handleTipoCodigoChange = event => {
    this.setState({ tipoCodigo: event.target.value });
  };

  onArchivoChange = file => {
    this.setState({ archivoImportado: file });
  };

  openDialog() {
    this.setState({
      open: true
    });
  }

  handleClose() {
    this.setState({
      open: false
    });
  }

  async submitDialog(values) {
    const { client } = this.props;

    await client
      .mutate({
        mutation: BeneficioGraphQL.mutations.createBeneficioTipo,
        variables: {
          tipo: {
            ...values
          }
        }
      })
      .then(res => {
        const mensaje = "Tipo creado y agregado corrrectamente";
        const tipo = res.data.createBeneficioTipo;
        const { tipos, initialValues } = this.state;
        tipos.push({ value: tipo._id, label: tipo.tipo });
        this.setState({
          tipos,
          open: false,
          initialValues: {
            ...initialValues,
            tipo: tipo._id
          }
        });
        this.props.openNotification(mensaje);
      })
      .catch(errors => {
        const arr = [];
        arr.push({ message: "Error inesperado" });
        this.setState({
          dialogErrors:
            errors.graphQLErrors.length !== 0 ? errors.graphQLErrors : arr
        });
        return false;
      });
  }

  render() {
    const {
      match: {
        params: { idBeneficio, id }
      }
    } = this.props;

    return (
      <Fragment>
        <Form
          id={parseInt(id) || id}
          idBeneficio={parseInt(idBeneficio) || idBeneficio}
          errors={this.state.errors}
          disabled={this.state.disabled}
          initialValues={this.state.initialValues}
          onSubmit={this.submit.bind(this)}
          handleChangeFecha={this.handleDateChange}
          sucursales={this.state.sucursales}
          tipos={this.state.tipos}
          openDialog={this.openDialog.bind(this)}
          logo={this.state.logo}
          onChangeLogo={this.onChangeLogo.bind(this)}
          onRemoveLogo={this.onRemoveLogo.bind(this)}
          imagenes={this.state.imagenes}
          onChangeImage={this.onChangeImage.bind(this)}
          onRemoveImage={this.onRemoveImage.bind(this)}
          paises={this.state.paises}
          onChangePais={this.onChangePais.bind(this)}
          rubros={this.state.rubros}
          onChangeRubro={this.onChangeRubro.bind(this)}
          segmentos={this.state.segmentos}
          onChangeSegmento={this.onChangeSegmento.bind(this)}
          codigosFijos={this.state.codigosFijos}
          codigosImportados={this.state.codigosImportados}
          onAgregarCodigoFijo={this.onAgregarCodigoFijo.bind(this)}
          onEliminarCodigoFijo={this.onEliminarCodigoFijo.bind(this)}
          onChangeCodigoFijo={this.onChangeCodigoFijo.bind(this)}
          onChangeSegmentosCodigoFijo={this.onChangeSegmentosCodigoFijo.bind(
            this
          )}
          tipoCodigo={this.state.tipoCodigo}
          onTipoCodigoChange={this.handleTipoCodigoChange}
          onArchivoChange={this.onArchivoChange}
        />
        <Dialog
          onSubmit={this.submitDialog.bind(this)}
          errors={this.state.dialogErrors}
          open={this.state.open}
          handleClose={this.handleClose.bind(this)}
        />
      </Fragment>
    );
  }
}

export default Edit;
